"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setChatId = exports.setDebug = exports.setRequestId = exports.setRuntimeId = exports.useTelemetry = void 0;
exports.useTelemetry = function (telemetry, ocSdkLogger, acsClientLogger, acsAdapterLogger, callingSdkLogger, amsClientLogger, ic3ClientLogger) {
    if (ic3ClientLogger === void 0) { ic3ClientLogger = null; }
    ocSdkLogger.useTelemetry(telemetry);
    acsClientLogger.useTelemetry(telemetry);
    acsAdapterLogger.useTelemetry(telemetry);
    callingSdkLogger.useTelemetry(telemetry);
    amsClientLogger.useTelemetry(telemetry);
    ic3ClientLogger === null || ic3ClientLogger === void 0 ? void 0 : ic3ClientLogger.useTelemetry(telemetry);
};
exports.setRuntimeId = function (runtimeId, ocSdkLogger, acsClientLogger, acsAdapterLogger, callingSdkLogger, amsClientLogger, ic3ClientLogger) {
    if (ic3ClientLogger === void 0) { ic3ClientLogger = null; }
    ocSdkLogger.setRuntimeId(runtimeId);
    acsClientLogger.setRuntimeId(runtimeId);
    acsAdapterLogger.setRuntimeId(runtimeId);
    callingSdkLogger.setRuntimeId(runtimeId);
    amsClientLogger.setRuntimeId(runtimeId);
    ic3ClientLogger === null || ic3ClientLogger === void 0 ? void 0 : ic3ClientLogger.setRuntimeId(runtimeId);
};
exports.setRequestId = function (requestId, ocSdkLogger, acsClientLogger, acsAdapterLogger, callingSdkLogger, amsClientLogger, ic3ClientLogger) {
    if (ic3ClientLogger === void 0) { ic3ClientLogger = null; }
    ocSdkLogger === null || ocSdkLogger === void 0 ? void 0 : ocSdkLogger.setRequestId(requestId);
    acsClientLogger === null || acsClientLogger === void 0 ? void 0 : acsClientLogger.setRequestId(requestId);
    acsAdapterLogger === null || acsAdapterLogger === void 0 ? void 0 : acsAdapterLogger.setRequestId(requestId);
    callingSdkLogger === null || callingSdkLogger === void 0 ? void 0 : callingSdkLogger.setRequestId(requestId);
    amsClientLogger === null || amsClientLogger === void 0 ? void 0 : amsClientLogger.setRequestId(requestId);
    ic3ClientLogger === null || ic3ClientLogger === void 0 ? void 0 : ic3ClientLogger.setRequestId(requestId);
};
exports.setDebug = function (flag, ocSdkLogger, acsClientLogger, acsAdapterLogger, callingSdkLogger, amsClientLogger, ic3ClientLogger) {
    if (ic3ClientLogger === void 0) { ic3ClientLogger = null; }
    ocSdkLogger === null || ocSdkLogger === void 0 ? void 0 : ocSdkLogger.setDebug(flag);
    acsClientLogger === null || acsClientLogger === void 0 ? void 0 : acsClientLogger.setDebug(flag);
    acsAdapterLogger === null || acsAdapterLogger === void 0 ? void 0 : acsAdapterLogger.setDebug(flag);
    callingSdkLogger === null || callingSdkLogger === void 0 ? void 0 : callingSdkLogger.setDebug(flag);
    amsClientLogger === null || amsClientLogger === void 0 ? void 0 : amsClientLogger.setDebug(flag);
    ic3ClientLogger === null || ic3ClientLogger === void 0 ? void 0 : ic3ClientLogger.setDebug(flag);
};
exports.setChatId = function (chatId, ocSdkLogger, acsClientLogger, acsAdapterLogger, callingSdkLogger, amsClientLogger, ic3ClientLogger) {
    if (ic3ClientLogger === void 0) { ic3ClientLogger = null; }
    ocSdkLogger === null || ocSdkLogger === void 0 ? void 0 : ocSdkLogger.setChatId(chatId);
    acsClientLogger === null || acsClientLogger === void 0 ? void 0 : acsClientLogger.setChatId(chatId);
    acsAdapterLogger === null || acsAdapterLogger === void 0 ? void 0 : acsAdapterLogger.setChatId(chatId);
    callingSdkLogger === null || callingSdkLogger === void 0 ? void 0 : callingSdkLogger.setChatId(chatId);
    amsClientLogger === null || amsClientLogger === void 0 ? void 0 : amsClientLogger.setChatId(chatId);
    ic3ClientLogger === null || ic3ClientLogger === void 0 ? void 0 : ic3ClientLogger.setChatId(chatId);
};
exports.default = {
    useTelemetry: exports.useTelemetry,
    setRuntimeId: exports.setRuntimeId,
    setRequestId: exports.setRequestId,
    setDebug: exports.setDebug,
    setChatId: exports.setChatId
};
//# sourceMappingURL=loggerUtils.js.map